module.exports = __webpack_public_path__ + "static/img/bg-overview@w.8bbc42a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/siliconwork-renewal/bg-overview@w.jpg
// module id = yM6o
// module chunks = 0